import React from 'react';
import {
  Grid,
  Dialog,
  DialogTitle,
  Zoom,
  Typography,
  CircularProgress,
  Button
} from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { withSnackbar } from 'notistack';
import CreateDocument from './CreateDocument';
const banks = [
  { label: 'Комерцијална банка АД Скопје', value: 'komercijalna' },
  { label: 'Народната Банка на Република Северна Македонија', value: 'narodna' },
  { label: 'Шпаркасе Банка Македонија АД Скопје', value: 'sparkase' },
  { label: 'Kапитал банка', value: 'kapital' }
  
];


class PageHeader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        open: false,
    }

  }

  handleCreateUserOpen = () => {
    this.setState({open :true});
  };

  handleCreateUserClose = (success) => {
    this.setState({open :false}, this.props.renderDocuments());
    if(success === true) {
      this.props.enqueueSnackbar('Документот е успешно креиран', {
        variant: 'success',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        TransitionComponent: Zoom
      });
    }
  };

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value,})
  }

  render() {
    return (
      <>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h3" component="h3" gutterBottom>
              {'Документи'}
            </Typography>
          </Grid>
          <Grid item>
          {this.props.predmet.user_write && <Button
              sx={{ mt: { xs: 2, sm: 0 } }}
              onClick={this.handleCreateUserOpen}
              variant="contained"
              startIcon={<AddTwoToneIcon fontSize="small" />}
            >
              {'Документ'}
            </Button>}
          </Grid>
        </Grid>
        {this.props.predmet.user_write && <Dialog
          fullWidth
          maxWidth="md"
          open={this.state.open}
          onClose={this.handleCreateUserClose}
        >
          <DialogTitle sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
              {'Нов документ'}
            </Typography>
            <Typography variant="subtitle2">
              {
                'Потполнете ги празнито поле додадете нов документ'
              }
            </Typography>
          </DialogTitle>
                <CreateDocument   handleCreateUserClose={this.handleCreateUserClose} userID={this.props.userID} id={this.props.id} predmet={this.props.predmet}  />
        </Dialog>}
      </>
    );
  }
  
}

export default withSnackbar(PageHeader);
